import React, { Component } from 'react';
import web3 from '../../../web3';
import vote from '../../../vote';
import "./Vote.css";
import Button from "../../Button/Button";
import Loader from '../../Loader2/Loader';
class Vote extends Component {
    state = {
        candidates: [],
        result: [],
        voted: false,
        selected: null,
        owner: false,
        load: false,
        load1: false,
        load2: false,
        load3: false
    }
    async componentDidMount() {
        this.setState({
            load: true
        })
        let voted = await vote.methods.haveVoted(this.props.index).call({ from: this.props.account });
        let owner = await vote.methods.elections(this.props.index).call({ from: this.props.account });
        owner = owner.creator;
        let boolVal = owner === this.props.account;

        let candidates = await vote.methods.getCandidates(this.props.index).call();
        let result = candidates[1];
        candidates = candidates[0].map(candidate => web3.utils.toAscii(candidate));
        this.setState({
            candidates: candidates,
            result,
            voted,
            owner: boolVal,
            load: false,
            deleted: false
        })
    }
    voteforCandidate = async (e) => {
        this.setState({
            load: true
        })
        e.preventDefault();
        await vote.methods.vote(this.props.index, this.state.selected).send({
            from: this.props.account
        })

        let candidates = await vote.methods.getCandidates(this.props.index).call();
        let result = candidates[1];
        candidates = candidates[0].map(candidate => web3.utils.toAscii(candidate));

        this.setState({
            voted: true,
            candidates,
            result,
            load: false
        })


    }
    handleSelection = (e) => {

        this.setState({
            selected: e.target.value
        })
    }

    freezeAccount = async () => {
        this.setState({
            load1: true
        })
        await vote.methods.closeVoting(this.props.index, false).send({
            from: this.props.account
        })
        this.setState({
            load1: false
        })
    }
    unfreezeAccount = async () => {
        this.setState({
            load2: true
        })
        await vote.methods.closeVoting(this.props.index, true).send({
            from: this.props.account
        })
        this.setState({
            load2: false
        })
    }
    deleteAccount = async () => {
        this.setState({
            load3: true
        })
        await vote.methods.deleteElection(this.props.index).send({
            from: this.props.account
        });
        this.setState({
            load3: false,
            deleted: true
        })
    }



    render() {
        let ownerOptions = (<div className="onlyOwner">
            <Button onClick={this.freezeAccount} load={this.state.load1}>Freeze Voting</Button>
            <Button onClick={this.unfreezeAccount} load={this.state.load2}>UnFreeze Voting</Button>
            <Button onClick={this.deleteAccount} load={this.state.load3}>Delete Election</Button>
        </div>);
        if (!this.state.owner) {
            ownerOptions = ("");
        }
        if (this.state.load) {
            return (
                <li className="vote">
                    <Loader />
                </li>
            )
        }
        if (this.state.deleted) {
            return (
                <li className="vote">
                    <h1>Deleted!</h1>
                </li>
            )
        }
        if (!this.state.voted)
            return (
                <li className="vote">
                    <form onSubmit={this.voteforCandidate}>
                        <div className="radios">
                            <table>
                                {this.state.candidates.map((candidate, i) => (
                                    <tr className="radio" key={i}>
                                        <td><input type="radio" onChange={this.handleSelection} value={i} name={"candidate_" + this.props.index} id={"candidate_" + this.props.index + i} checked={parseInt(this.state.selected,10) === i} required /></td>
                                        <td><label htmlFor={"candidate_" + this.props.index + i}>{candidate}</label></td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                        <button>Vote</button>
                    </form>
                    <br />
                    <div className="result">
                        <h3>Vote Count Till now</h3><br />
                        <table>
                            <tbody>
                                {this.state.candidates.map((candidate, i) => {
                                    return (<tr key={i}><td>{candidate}</td><td> {this.state.result[i]}</td></tr>);
                                })}
                            </tbody>
                        </table>
                    </div><br />
                    <h6> Creator: {this.props.creator}</h6>
                    {ownerOptions}
                </li>
            );
        else
            return (
                <div className="vote"><h2>You Already Voted</h2>
                    <div className="result">
                        <h3>Vote Count Till now</h3><br />
                        <table>
                            <tbody>
                            {this.state.candidates.map((candidate, i) => {
                                return (<tr key={i}><td>{candidate}</td><td> {this.state.result[i]}</td></tr>);
                            })}
                            </tbody>
                        </table>
                    </div><br />
                    <h6> Creator: {this.props.creator}</h6>
                    {ownerOptions}
                </div>);
    }
};
export default Vote;


// WEBPACK FOOTER //
// ./src/components/Votes/Vote/Vote.js